import { type ReactNode, Children } from 'react';

export const CONTROL_WIDTH = 37.5;

/**
 * Estimates toolbar size depending on children count
 *
 * @param children -
 */
export const estimateToolbarWidth = (children: ReactNode) =>
  Children.count(children) * CONTROL_WIDTH;
